import { useEffect, useState } from "react"
import { formatDateTime, formatRelativeTime } from "../../lib/format-date"

export function RelativeTime({ iso }: { iso: string }) {
  const [label, setLabel] = useState(() => formatRelativeTime(iso))
  useEffect(() => {
    setLabel(formatRelativeTime(iso))
    const timer = setInterval(() => setLabel(formatRelativeTime(iso)), 30_000)
    return () => clearInterval(timer)
  }, [iso])
  return (
    <time dateTime={iso} title={formatDateTime(iso)}>
      {label}
    </time>
  )
}
